export const heightFooterSticky = 82
export const heightHeader = 55
export const heightCategory = 67
export const marginX = 20
